import VectorImageLayer from 'ol/layer/VectorImage.js';
import CustomVectorImageRenderer from './../render/canvas/CustomVectorImageRenderer.js';

class VectorImage extends VectorImageLayer {
    constructor(options) {
        super(options);
    }

  createRenderer() {
    return new CustomVectorImageRenderer(this);
  }

}

export default VectorImage;

// re-export everything from OL
export * from 'ol/layer/VectorImage.js';